var React = require('react');

function Change (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.0429 3.26579C10.7829 2.30096 9.20998 1.72369 7.49593 1.72369C3.34911 1.72369 0 5.0812 0 9.22369C0 13.3662 3.34911 16.7237 7.49593 16.7237C10.9986 16.7237 13.9148 14.3294 14.7487 11.0986L15 10.3581H11.207L11.1462 10.5165C10.6161 12.0218 9.18077 13.0987 7.49593 13.0987C5.35657 13.0987 3.61789 11.3602 3.61789 9.22369C3.61789 7.08719 5.35657 5.34869 7.49593 5.34869C8.20157 5.34869 8.85862 5.54234 9.42673 5.88033L5.89366 9.41119H15V0.310547L12.0429 3.26579Z","fill":"currentColor"}));
}

Change.defaultProps = {"aria-hidden":"true","viewBox":"0 0 15 17","width":"100%","fill":"none"};

module.exports = Change;

Change.default = Change;
